import * as ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscount from './loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.http.js';
import * as ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscountTypes from './loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.types.js';
import * as ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscountUniversalTypes from './loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function applyDiscountToCheckout(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscountUniversalTypes.ApplyDiscountToCheckoutRequest,
  ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscountTypes.ApplyDiscountToCheckoutRequest,
  ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscountUniversalTypes.ApplyDiscountToCheckoutResponse,
  ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscountTypes.ApplyDiscountToCheckoutResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscount.applyDiscountToCheckout(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/loyalty-checkout-discount',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryLoyaltyCheckoutDiscounts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscountUniversalTypes.QueryLoyaltyCheckoutDiscountsRequest,
  ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscountTypes.QueryLoyaltyCheckoutDiscountsRequest,
  ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscountUniversalTypes.QueryLoyaltyCheckoutDiscountsResponse,
  ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscountTypes.QueryLoyaltyCheckoutDiscountsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscount.queryLoyaltyCheckoutDiscounts(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/loyalty-checkout-discounts/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  LoyaltyCheckoutDiscount as LoyaltyCheckoutDiscountOriginal,
  LoyaltyCheckoutDiscountDiscountOneOf as LoyaltyCheckoutDiscountDiscountOneOfOriginal,
  DiscountStatus as DiscountStatusOriginal,
  DiscountStatusWithLiterals as DiscountStatusWithLiteralsOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  DiscountRefundedDueToManualDiscountRemoval as DiscountRefundedDueToManualDiscountRemovalOriginal,
  DiscountRefundedDueToTimeout as DiscountRefundedDueToTimeoutOriginal,
  DiscountScheduledForRefund as DiscountScheduledForRefundOriginal,
  ApplyDiscountToCheckoutRequest as ApplyDiscountToCheckoutRequestOriginal,
  ApplyDiscountToCheckoutRequestDiscountOneOf as ApplyDiscountToCheckoutRequestDiscountOneOfOriginal,
  Reward as RewardOriginal,
  LoyaltyCoupon as LoyaltyCouponOriginal,
  ReferralReward as ReferralRewardOriginal,
  ApplyDiscountToCheckoutResponse as ApplyDiscountToCheckoutResponseOriginal,
  QueryLoyaltyCheckoutDiscountsRequest as QueryLoyaltyCheckoutDiscountsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryLoyaltyCheckoutDiscountsResponse as QueryLoyaltyCheckoutDiscountsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.types.js';
